/**
 * tasksense-userdata-service API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UserDataBulkRowResult { 
    /**
     * Zero-based row index in the request payload.
     */
    index?: number;
    /**
     * Echo of the request row\'s type (null/blank passed through unchanged).
     */
    type?: string;
    /**
     * Echo of the request row\'s key (null/blank passed through unchanged).
     */
    key?: string;
    /**
     * Resolved outcome — what would happen (dryRun) or what happened (commit).
     */
    outcome?: UserDataBulkRowResult.OutcomeEnum;
    /**
     * Human-readable error reason. Populated only for ERROR outcomes.
     */
    error?: string;
}
export namespace UserDataBulkRowResult {
    export const OutcomeEnum = {
        Create: 'CREATE',
        Update: 'UPDATE',
        Skip: 'SKIP',
        Error: 'ERROR'
    } as const;
    export type OutcomeEnum = typeof OutcomeEnum[keyof typeof OutcomeEnum];
}


